import { render, staticRenderFns } from "./PromoBarTest.vue?vue&type=template&id=49ef4f1c&"
import script from "./PromoBarTest.vue?vue&type=script&lang=js&"
export * from "./PromoBarTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports